<template>
  <footer>
    <span class="component-label">{{'&lt;' + $options.name + ' />'}}</span>
  </footer>
</template>
<script>
export default {
  name: 'AccountLayoutFooter'
}
</script>



// WEBPACK FOOTER //
// src/layouts/account-layout/AccountLayoutFooter.vue